import { useState } from "react"
import SkeletonLink from "components/common/skeleton-link"
import { useTranslation } from "lib/i18n/translation"
import { useBonus } from "lib/bonus"
import { useCountry } from "lib/country"
import ProductAccessLink from "components/common/product-access-link"
import { BONUS_ARCHIVES, BONUS_EXCLUSIFS } from "lib/tools/product"
import classification from "lib/tools/classification"
import { useMainCategories } from "lib/tools/categories"

export default (({ film, list, hasComments, director, loading }) => {
	const { allLists } = useMainCategories()
	const { c, ec } = useTranslation("common")
	const [opened, setOpened] = useState(false)
	const { showBonuses } = useBonus()
	const { country } = useCountry()

	const recommenders = film.recommendersIds ? film.recommendersIds.filter(id => id !== director.id).map(r => allLists.find(l => l.director.id == r)).filter(l => l !== undefined) : []
	const commentKey = `list-comment-${list.id}-${film.id}`
	let comment = c(commentKey)
	if (comment == commentKey) comment = null

	return (
		<li className={`item ${film.inMonthSelection ? "in-selection" : ""} ${(!film.countriesAvailability[country.isoCode]) ? "unavailable" : ""} ${film.availableSoon ? "soon" : ""}`}>
			<div className="item-content" style={hasComments ? {} : { padding: "1rem" }}>
				{hasComments
					? <nav className={`director-actions ${loading ? "skeleton" : ""}`}>
						{comment
							? <a
								href="#"
								onClick={e => { e.preventDefault(); setOpened(!opened) }}
								rel="nofollow noopener"
								title={c("display-description")}
								className={`collapsible-toggle ${opened ? "active" : ""}`}
							>
								{ec("display-description")}
							</a>
							: null
						}
					</nav>
					: null
				}
				<div className="infos">
					<SkeletonLink
						href="/film/[id]"
						as={`/film/${film.linkRewrite}`}
						key={`film-link-${film.id}`}
					>
						<a title={c("see-single-film")} className="film-link">
							<h3 className={`title ${loading ? "skeleton" : ""}`}>
								{film.name}
								{classification(film)}
								{
									film.original_title
									&& film.original_title !== film.name
									&& <span className="original">{film.original_title}</span>
								}
							</h3>
						</a>
					</SkeletonLink>
					<div className={`film-infos ${loading ? "skeleton" : ""}`}>
						<span className="director">{film.director}</span>
						<span className="year">{film.year}</span>
						<span className="country">{film.origin}</span>
						<span className="duration">{film.duration}</span>
					</div>
				</div>
				<div className="film-bonus">
					{(film.bonusesArchivesCount + film.bonusesExclusifsCount) > 0
						? <nav className="has-bonus" aria-label={c("see-related-content")}>
							{film.bonusesExclusifsCount > 0
								? <a
									href="#"
									onClick={e => { e.preventDefault(); showBonuses(film, BONUS_EXCLUSIFS, c("bonus-exclusifs-title")) }}
									rel="nofollow noopener"
									title={c("watch-exclusifs-bonus")}
									data-overlay="#overlay-bonus-exclusive"
									className="icon-bonus-exclusive exclusive"
								>
									{c("bonus-exclusifs-title")}
								</a>
								: null
							}
							{film.bonusesArchivesCount > 0
								? <a
									href="#"
									onClick={e => { e.preventDefault(); showBonuses(film, BONUS_ARCHIVES, c("bonus-archives-title")) }}
									rel="nofollow noopener"
									title={c("watch-archives-bonus")}
									data-overlay="#overlay-bonus-archives"
									className="icon-bonus-archives archives"
								>
									{c("bonus-archives-title")}
								</a>
								: null
							}
						</nav>
						: null
					}
				</div>
				<p className={`is-recommended ${loading ? "skeleton" : ""}`}>
					{recommenders.length > 0
						? <>
							<b>{c("also-recommended-by")}</b>
							{recommenders.map((list, index) => (
								<SkeletonLink
									href={`/lists/[id]`}
									as={`/lists/${c(list.linkRewrite)}`}
									key={`list-link-${index}`}
								>
									<a title={c("see-list")}>{list.name.replace(" | ", " ")}</a>
								</SkeletonLink>
							))}
						</>
						: null
					}
				</p>
				{comment
					? <div
						id={`comments_${list.id}_${film.id}`}
						className={`comments collapsible ${opened ? "active" : ""} ${loading ? "skeleton" : ""}`}
						dangerouslySetInnerHTML={{ __html: comment.replace("\n", "<br />") }}
					/>
					: null
				}
			</div>
			<nav className="film-actions" aria-label={c("film-actions")}>
				{loading
					? null
					: <ProductAccessLink product={film} />
				}
			</nav>
		</li>
	)
})
